export default __webpack_public_path__ + "static/media/bio-avatar-sq.61a0316f.png";